/**
 * How often a tab without a live call asks the server whether one started elsewhere (another tab,
 * a missed push). Focus and reconnect trigger the same check immediately.
 */
export const IDLE_CALL_DISCOVERY_INTERVAL_MS = 120000;
